import * as React from "react";
import type { SVGProps } from "react";

interface GoalOpportunityProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const GoalOpportunity = ({ cancelled = false, ...props }: GoalOpportunityProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M16.6 2.42a1.62 1.62 0 1 1-1.4 2.93 7.34 7.34 0 0 0-3.2-.72 1.63 1.63 0 1 1 0-3.25c1.61 0 3.18.36 4.6 1.04m5.76 7.2a1.62 1.62 0 1 1-3.17.72 7.34 7.34 0 0 0-1.43-2.95 1.63 1.63 0 0 1 2.54-2.03c1 1.25 1.7 2.7 2.06 4.26m-2 8.94a1.62 1.62 0 1 1-2.56-2 7.34 7.34 0 0 0 1.4-2.97 1.62 1.62 0 1 1 3.18.7 10.6 10.6 0 0 1-2.02 4.27m-8.33 4.06a1.63 1.63 0 0 1-.01-3.25c1.12 0 2.2-.25 3.2-.73a1.63 1.63 0 0 1 1.4 2.93 10.6 10.6 0 0 1-4.6 1.05Zm-8.25-3.9a1.63 1.63 0 0 1 2.51-2.05 7.4 7.4 0 0 0 2.59 2.01 1.63 1.63 0 0 1-1.38 2.95 10.66 10.66 0 0 1-3.72-2.9ZM1.6 9.83a1.62 1.62 0 1 1 3.18.67 7.5 7.5 0 0 0 .06 3.28 1.62 1.62 0 1 1-3.16.78 10.65 10.65 0 0 1-.08-4.73m5.6-7.3a1.62 1.62 0 0 1 1.47 2.9 7.4 7.4 0 0 0-2.53 2.1 1.63 1.63 0 1 1-2.58-1.98c.97-1.26 2.21-2.3 3.63-3.02ZM12 1.38a1.63 1.63 0 0 1 0 3.25h-.16a1.63 1.63 0 1 1-.07-3.25z"
      />
      <path
        fill="#000"
        d="M16.18 3.3a.65.65 0 1 1-.56 1.17A8.3 8.3 0 0 0 12 3.65a.65.65 0 1 1 0-1.3c1.47 0 2.89.33 4.18.95m5.23 6.53a.65.65 0 0 1-1.27.3 8.3 8.3 0 0 0-1.62-3.34.65.65 0 0 1 1.02-.82 9.6 9.6 0 0 1 1.87 3.86m-1.82 8.13a.65.65 0 0 1-1.02-.8 8.3 8.3 0 0 0 1.59-3.36.65.65 0 0 1 1.27.28 9.6 9.6 0 0 1-1.84 3.88m-7.57 3.69a.65.65 0 0 1 0-1.3c1.27 0 2.5-.29 3.62-.83a.65.65 0 1 1 .56 1.17c-1.29.63-2.71.96-4.18.96m-7.49-3.54a.65.65 0 0 1 1-.82c.8.96 1.8 1.75 2.93 2.28a.65.65 0 0 1-.55 1.17 9.7 9.7 0 0 1-3.38-2.63m-1.98-8.09a.65.65 0 0 1 1.28.27A8.5 8.5 0 0 0 3.89 14a.65.65 0 1 1-1.26.31 9.7 9.7 0 0 1-.08-4.29M7.63 3.4a.65.65 0 1 1 .6 1.16 8.4 8.4 0 0 0-2.86 2.37.65.65 0 0 1-1.03-.79c.88-1.14 2-2.08 3.3-2.74ZM12 2.35a.65.65 0 0 1 0 1.3h-.18a.65.65 0 1 1-.03-1.3h.2Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default GoalOpportunity;
